import { SharedApiV2 } from "mock-api/src/public-api";
import { PaginatedListQuery } from "src/app/core/request-v2-utils";
import { Site } from "src/app/core/sites";

export class CarrierSelectedListQueryModel extends PaginatedListQuery {
  public constructor(args: ClassProperties<CarrierSelectedListQueryModel>) {
    super(args);
    this.searchQuery = args.searchQuery;
    this.siteId = args.siteId;
  }

  public readonly searchQuery?: string;
  public readonly siteId?: Site["id"];

  public serialize(): SharedApiV2.GetCarriersSelectedListQuery {
    return {
      ...this.serializeBase(),
      filter: {
        search: this.searchQuery ?? null,
        siteId: this.siteId ?? null,
      },
    };
  }
}
